import { mapGetters } from 'vuex'
import {
  fetchLinkPreviewUrl,
  fetchPlanUrl,
  fetchShortLinksUrl,
  fetchSocialMentionSuggestionsUrl, uploadDocumentAssetUrl,
  uploadMediaAssetUrl,
} from '@src/modules/publish/config/api-utils'
import proxy from '@common/lib/http-common'
import { UNKNOWN_ERROR } from '@common/constants/messages'
import {createEditor} from "@postnitro/embed";
import {MULTIMEDIA_ALLOWED_PLATFORMS} from "@common/constants/composer";
import { apiUrl, isWhiteLabelDomain } from '@src/config/api-utils'

const ComposerHelperMixin = {
  data() {
    return {
      instagramPostingMethod: null,
    }
  },
  created: function () {},
  computed: {
    ...mapGetters([
      'getWorkspaces',
      'getPublishSelection',
      'getActiveWorkspaceMembersName',
      'getActiveWorkspaceMembersIds',
      'getPublishLoaders',
      'getLinkedinSharingLoaders',
      'getInstagramSharingLoaders',
      'getGmbSharingLoaders',
    ]),

    /**
     * Returns currently set workspace timezone.
     * @returns {string}
     */
    workspaceTimezone() {
      return this.getWorkspaces.activeWorkspace.timezone
    },
  },
  methods: {
     /**
      * This method is used to check if the type is common or instagram
      * Moreover we are using this for Instagram carousel
      * @param {*} type
      * @returns
      */
     isTypeCommonOrInstagram(type) {
      return ['common'].concat(MULTIMEDIA_ALLOWED_PLATFORMS).includes(type)
     },
     /**
     * @description - This method is used to open postnitro modal
     * @param {string} type
     * @param getSharingDetails {function}
     * @param cancelledLink {string}
     * @param callbackFunction {function} - callback function params (actionType {string}, payload: {object})
     * @param fileReplaceConfirmation {function} - callback function to confirm file replace
     */
     openPostNitroModal(
      type,
      getSharingDetails,
      cancelledLink,
      callbackFunction,
      fileReplaceConfirmation = null
    ) {
      // initialize postnitro editor
      const editor = createEditor({
        apiKey: process.env.VUE_APP_POSTNITRO_API_KEY || 'pn-eotw1rjoeqv7vkvh6n9u4x3j',
      })

      // open postnitro modal
      editor?.createDesign((data) => {
        console.debug('callback from postnitro', data)
        if (!(data?.images && Array.isArray(data.images) && data.images.length > 0)) {
          return
        }

        const slides = []
        // add image names to slides
        data.images.forEach((image, index) => {
          const file = new File(
            [image],
            data?.name + '-slide-' + (index+1) + '.png',
            { type: 'image/png' }
          )
          slides.push(file)
        })

        // upload images to server
        this.CSUploadImage(
          {
            postnitroCarouselId: data?.id,
            target: {
              files: slides,
            },
          },
          type,
          getSharingDetails,
          cancelledLink,
          callbackFunction,
          fileReplaceConfirmation,
          true
        )

        editor?.destroy()
      })
    },
    async CSUploadPdf(
        event,
        type,
        callbackFunction,
        fileReplaceConfirmation = null
    ){

      let file = []
      if (event.type === 'paste') {
        const itemFiles = []
        const items = (event.clipboardData || event.originalEvent.clipboardData)
            .items
        for (let i = 0; i <= items.length - 1; i++) {
          itemFiles.push(items[i].getAsFile())
        }
        file = itemFiles
        console.debug('Method::parseFilesMimeTypes ~ Files -> ', file)
      } else {
        file = event.target.files || event.dataTransfer.files
      }
      if (file[0]) {
        const formData = new FormData()
        formData.append('file', file[0])
        formData.append('workspace_id', this.getWorkspaces.activeWorkspace._id)

        if(fileReplaceConfirmation && await fileReplaceConfirmation() === false) {
          return false
        }

        this.CSProcessPdfUpload(event, formData, callbackFunction)
        event.target.value = ''
      } else {
        this.alertMessage('No file selected.', 'error')
      }
    },

    CSProcessPdfUpload(event, formData, callbackFunction) {
      // setting loaders for video upload
      callbackFunction('local-property', {
        propertyName: 'mediaUploadLoader',
        value: true,
      })
      callbackFunction('local-property', {
        objectName: 'progressBar',
        propertyName: 'video',
        value: 0,
      })
      const self = this
      const ajax = new XMLHttpRequest()

      ajax.upload.addEventListener('progress', function (progressEvent) {
        let percent = (event.loaded / event.total) * 100
        percent = Math.round(percent)
        callbackFunction('local-property', {
          objectName: 'progressBar',
          propertyName: 'video',
          value: percent,
        })
      })

      ajax.addEventListener('load', function (loadEvent) {
        self.CSPdfUploadCompleteHandler(loadEvent, callbackFunction)
      })

      ajax.addEventListener('error', function (error) {
        console.error('Method:videoFileUploadErrorHandler', error)
        self.alertMessage(error.message || UNKNOWN_ERROR, 'error')
        // hide loader of upload
        callbackFunction('local-property', {
          propertyName: 'mediaUploadLoader',
          value: false,
        })
      })

      ajax.open('POST', uploadDocumentAssetUrl)
      ajax.setRequestHeader('Authorization', 'Bearer ' + this.getJWTToken)
      ajax.setRequestHeader('Accept', 'application/json')
      ajax.send(formData)
    },


    /**
     * This method will be called when Document uploaded completely.
     * @param event - event object
     * @param callbackFunction - callback function
     */
    CSPdfUploadCompleteHandler(event, callbackFunction) {

      try {
        let response = event.target.responseText
        response = JSON.parse(response)

        if (response.status === true && response.document) {

          const doc = {
            name: response.document.name || '',
            link: response.document.link || '',
            thumbnail: response.document.thumbnail || '',
            no_of_pages: response.document.no_of_pages ||  0,
          }

          // setting state of uploaded document details
          callbackFunction('addDocument', {
            mediaType: 'doc',
            document: doc,
          })
        } else if (response.storageFull) {
          // commit('setMediaStorageLimit', response.usedStorage)
          this.setMediaStorageLimit(response.usedStorage)
          this.$bvModal.show('media-storage-limits-exceeded-modal')
        } else if (
            response.message &&
            response.message.includes('format is not correct')
        ) {
          this.alertMessage(response.message, 'error')
        } else {
          this.alertMessage('Unable to upload PDF.', 'error')
        }
      } catch (e) {
        console.error('Exception: pdfFileUploadCompleteHandler-Composer-v2', e)
        this.alertMessage('Unable to upload PDF.', 'error')
      }
      // hide loader of video upload
      this.mediaUploadLoader = false
      callbackFunction('local-property', {
        propertyName: 'mediaUploadLoader',
        value: false,
      })
    },

    /**
     * @description Editor Upload Image
     * @param {Object} event
     * @param {string} type
     * @param getSharingDetails {function}
     * @param cancelledLink {string}
     * @param callbackFunction {function} - callback function params (actionType {string}, payload: {object})
     * @param fileReplaceConfirmation {function} - callback function to confirm file replace
     * @param isPostnitro {boolean} - flag to check if the image is uploaded from postnitro
     * @returns {Promise<any>}
     */
    async CSUploadImage(
        event,
        type,
        getSharingDetails,
        cancelledLink,
        callbackFunction,
        fileReplaceConfirmation = null,
        isPostnitro = false
    ) {
      console.debug('Method:uploadSharingImage-v2', event, type)
      const details = getSharingDetails()
      let files = []
      if (event.type === 'paste') {
        const itemImages = []
        const items = (event.clipboardData || event.originalEvent.clipboardData)
            .items
        for (let i = 0; i <= items.length - 1; i++) {
          const item = items[i].getAsFile()
          if (item) {
            itemImages.push(item)
          }
        }
        files = itemImages
      } else {
        files = event.target.files || event.dataTransfer.files
      }

      const formData = new FormData()

      const fileType = []
      let gifCount = 0

      if(files.length === 0) {
        this.alertMessage('No file selected.', 'error')
        return
      }

      for (let i = 0; i < files.length; i++) {
        if (files[i].type === 'image/gif') {
          gifCount = gifCount + 1
        }

        if (fileType.includes(files[i].type) === false) {
          fileType.push(files[i].type)
        }

        formData.append('media_assets[]', files[i])
      }

      formData.append('workspace_id', this.getActiveWorkspace._id)
      formData.append('folder_id', null)

      if(isPostnitro) {
        formData.append('source', 'postnitro')
        formData.append('postnitro_carousel_id', event?.postnitroCarouselId)
      }

      if(fileReplaceConfirmation && await fileReplaceConfirmation() === false) {
        return
      }

      if (
          fileType.includes('image/gif') &&
          (fileType.includes('image/jpg') ||
              fileType.includes('image/jpeg') ||
              fileType.includes('image/png'))
      ) {
        this.alertMessage('Please upload one file type at a time.', 'error')
        return false
      } else if (gifCount > 1) {
        this.alertMessage(
            'Your are allowed to upload only 1 GIF image.',
            'error'
        )
        return false
      } else {
        if (details.url) {
          console.debug('Method:Reset Image', details)
        }

        callbackFunction('local-property', {
          objectName: 'progressBar',
          propertyName: 'numberOfImages',
          value: files.length,
        })
        const images = details.url ? [] : [...details.image]
        if (images && images.length > 0) {
          images.forEach((el, index) => {
            const extension = el?.split('.')?.pop()

            if (extension === 'gif') {
              gifCount = gifCount + 1
            }

            if (fileType.includes('image/' + extension) === false) {
              fileType.push('image/' + extension)
            }
          })
        }
        console.debug('Method:uploadSharingImage-v2', fileType, gifCount)
        if (gifCount > 1) {
          if (!(await this.confirmGifReplace(type))) return false
        } else if (
            fileType.includes('image/gif') &&
            (fileType.includes('image/jpg') ||
                fileType.includes('image/jpeg') ||
                fileType.includes('image/png'))
        ) {
          if (await this.confirmCurrentTypeReplace(type)) {
            console.debug('Method:uploadSharingImage-v2', fileType)
            callbackFunction('removeMedia', {
              mediaType: 'image',
              media: null,
              removeAll: true,
            })
          } else {
            return false
          }
        }
        if (details.url) {
          callbackFunction('removeLinkPreview', {})
        }
        callbackFunction('removeMedia', {
          mediaType: 'video',
          media: null,
          removeAll: false,
        })
        callbackFunction('local-property', {
          propertyName: 'mediaUploadLoader',
          value: true,
        })
        this.CSProcessImageUpload(
            event,
            formData,
            type,
            getSharingDetails,
            cancelledLink,
            callbackFunction
        )
      }
    },

    /**
     * @description Editor Process Image Upload
     * @param {Object} event
     * @param {Object} formData
     * @param {string} type
     * @param getSharingDetails {function}
     * @param cancelledLink {string}
     * @param callbackFunction {function} - callback function params (actionType {string}, payload: {object})
     */
    CSProcessImageUpload(
        event,
        formData,
        type,
        getSharingDetails,
        cancelledLink,
        callbackFunction
    ) {
      console.debug(
          'Method:processSharingImageUpload-v2',
          event,
          formData,
          type,
          getSharingDetails,
          cancelledLink,
          callbackFunction
      )
      callbackFunction('local-property', {
        objectName: 'progressBar',
        propertyName: 'image',
        value: 0,
      })
      const stateObject = this
      const ajax = new XMLHttpRequest()

      ajax.upload.addEventListener('progress', function (progressEvent) {
        stateObject.CSImageUploadProgressHandler(
            progressEvent,
            type,
            getSharingDetails,
            cancelledLink,
            callbackFunction
        )
      })

      ajax.addEventListener('load', function (loadEvent) {
        stateObject.CSImageUploadCompleteHandler(
            loadEvent,
            type,
            getSharingDetails,
            cancelledLink,
            callbackFunction
        )
      })

      ajax.addEventListener('error', function (loadEvent) {
        stateObject.CSImageUploadErrorHandler(loadEvent, callbackFunction)
      })

      ajax.open('POST', uploadMediaAssetUrl)
      ajax.setRequestHeader('Authorization', 'Bearer ' + this.getJWTToken)
      ajax.send(formData)

      event.target.value = ''
    },

    /**
     * @description Editor Image Upload Complete Handler
     * @param {Object} event
     * @param {string} type
     * @param getSharingDetails {function}
     * @param cancelledLink {string}
     * @param callbackFunction {function} - callback function params (actionType {string}, payload: {object})
     */
    CSImageUploadProgressHandler(
        event,
        type,
        getSharingDetails,
        cancelledLink,
        callbackFunction
    ) {
      console.debug('Method:sharingImageUploadProgressHandler-v2', event)
      let percent = (event.loaded / event.total) * 100
      percent = Math.round(percent)
      console.debug('Method:sharingImageUploadProgressHandler-v2', percent)
      callbackFunction('local-property', {
        objectName: 'progressBar',
        propertyName: 'image',
        value: percent,
      })
    },

    /**
     * @description Editor Image Upload Complete Handler
     * @param {Object} event
     * @param {string} type
     * @param getSharingDetails {function}
     * @param cancelledLink {string}
     * @param callbackFunction {function} - callback function params (actionType {string}, payload: {object})
     */
    CSImageUploadCompleteHandler(
        event,
        type,
        getSharingDetails,
        cancelledLink,
        callbackFunction
    ) {
      const details = getSharingDetails()
      try {
        let response = event.target.responseText
        response = JSON.parse(response)
        response.media = response.media_container

        // For instagram or common we will upload media in multimedia
        if(['common'].concat(MULTIMEDIA_ALLOWED_PLATFORMS).includes(type) && response?.media?.length) {
          this.$store.dispatch('updateSocialSharingMedia', response.media)
          callbackFunction('addMedia', { mediaType: 'multimedia', media: response.media.map(el => el.link) })
        }

        let images = details.image ? [...details.image] : []
        if (response.status === true) {
          this.$store.dispatch('updateSocialSharingMedia', response.media)
          switch (type) {
            case 'common':
            case 'facebook':
            case 'linkedin':
            case 'tiktok':
              response.media.forEach(function (el, index) {
                images.push(el.link)
              })
              break
            case 'twitter':
            case 'threaded-tweet':
              response.media.forEach(function (el, index) {
                if (images.length > 3) {
                  images.pop()
                }
                images.push(el.link)
              })
              break
            case 'instagram':
              response.media.forEach(function (el, index) {
                if (images.length > 9) images.pop()
                images.push(el.link)
              })
              break
            case 'bluesky':
              response.media.forEach(function (el, index) {
                if (images.length > 4) images.pop()
                images.push(el.link)
              })
              break
            case 'bluesky-tweet':
              response.media.forEach(function (el, index) {
                if (images.length > 4) images.pop()
                images.push(el.link)
              })
              break
            case 'pinterest':
            case 'tumblr':
            case 'gmb':
              images = [response.media[0].link]
              break
          }

          // For in case of uploading multimedia in the multi threads we will not call the images
          if(!['multi-threads'].includes(type)) {
            callbackFunction('addMedia', { mediaType: 'image', media: images })
          }

        } else if (response.storageFull) {
          this.setMediaStorageLimit(response.usedStorage)
          this.$bvModal.show('media-storage-limits-exceeded-modal')
        } else {
          this.alertMessage(response.message, 'error')
        }
      } catch (e) {
        console.debug('Exception::sharingImageUploadCompleteHandler-v2', e)
        this.alertMessage('Unable to upload image(s).', 'error')
      }

      callbackFunction('local-property', {
        propertyName: 'mediaUploadLoader',
        value: false,
      })
      callbackFunction('local-property', {
        objectName: 'progressBar',
        propertyName: 'image',
        value: 0,
      })
    },

    /**
     * @description Editor Image Upload Error Handler
     * @param {Object} event
     * @param callbackFunction {function} - callback function params (actionType {string}, payload: {object})
     */
    CSImageUploadErrorHandler(event, callbackFunction) {
      console.error('Method:sharingImageUploadErrorHandler-v2')
      this.alertMessage(UNKNOWN_ERROR, 'error')
      callbackFunction('local-property', {
        propertyName: 'mediaUploadLoader',
        value: false,
      })
      callbackFunction('local-property', {
        objectName: 'progressBar',
        propertyName: 'image',
        value: 0,
      })
    },

    /**
     * @description Composer Video Upload
     * @param {String} type
     * @param {Object} event
     * @param getSharingDetails {function}
     * @param callbackFunction {function} - callback function params (actionType {string}, payload: {object})
     * @param fileReplaceConfirmation {function} - callback function to confirm file replace
     */
    async CSUploadVideo(event, type, getSharingDetails, callbackFunction, fileReplaceConfirmation = null) {
      console.debug('Action:composerUploadVideo', event)
      // const details = getSharingDetails()

      let file = []
      if (event.type === 'paste') {
        const itemFiles = []
        const items = (event.clipboardData || event.originalEvent.clipboardData)
            .items
        for (let i = 0; i <= items.length - 1; i++) {
          itemFiles.push(items[i].getAsFile())
        }
        file = itemFiles
        console.debug('Method::parseFilesMimeTypes ~ Files -> ', file)
      } else {
        file = event.target.files || event.dataTransfer.files
      }

      if(!file.length) {
        this.alertMessage('No file selected.', 'error')
        return false
      }

      const formData = new FormData()
      for (let i = 0; i < file.length; i++) {
        formData.append('media_assets[]', file[i])
      }

      formData.append('folder_id', null)
      formData.append('workspace_id', this.getWorkspaces.activeWorkspace._id)

      if(fileReplaceConfirmation && await fileReplaceConfirmation() === false) {
        return false
      }

      // direct uplaod to gcs is not working on whitelabel domains due to cors issue
      // TODO: need to check if we can upload to gcs directly from whitelabel domains
      // temporarily using old composer upload for whitelabel domains
      if(isWhiteLabelDomain()) {
        this.CSProcessVideoUpload(event, formData, callbackFunction)
      } else {
        this.processCSVideoUploadForGCS(event, formData, callbackFunction)
      }
      event.target.value = ''

    },

    /**
     * TODO: we need to check the available limit when the user selects file,
     * If we do it only for videos, then we are not sure whether the combined
     * data (images, videos and pdfs) exceeds the limit or not
    */
    async processCSVideoUploadForGCS(event, formData, callbackFunction) {
      // Get file details, name, mime_type, extention and size
      const filesDetails = this.getFilesDetails(formData.getAll('media_assets[]'))

      // generate unique URL for each file object
      const signedUrlfilesDetails = await this.generateUniqueURLsForFiles(
        filesDetails,
        formData.get('workspace_id')
      )
      if (
        !signedUrlfilesDetails.status &&
        signedUrlfilesDetails.error === 'workspace_limit_exceeds'
      ) {
        this.setMediaStorageLimit(signedUrlfilesDetails.data.usedStorage)
        this.$bvModal.show('media-storage-limits-exceeded-modal')
        return false
      }

      // upload each file using the url for that individual file
      const uploadedSignedUrlfilesDetails = await this.uploadMediaToGCS(
        signedUrlfilesDetails,
        formData.getAll('media_assets[]'),
        callbackFunction
      )
      if (!uploadedSignedUrlfilesDetails || uploadedSignedUrlfilesDetails.length === 0) {
        this.alertMessage('Error in fetching media', 'error')
        return false
      }

      const uploadedMediaDetails = await this.UploadedCSVideoHandlerForGCS(
        uploadedSignedUrlfilesDetails,
        this.getWorkspaces.activeWorkspace._id
      )
      if (!uploadedMediaDetails || !uploadedMediaDetails.status) {
        this.alertMessage('Error in uploading media', 'error')
        return false
      }

      this.CSVideoUploadCompleteHandler(
        {target: {responseText: JSON.stringify(uploadedMediaDetails)} },
        callbackFunction
      )
    },

    getFilesDetails(files) {
      const fileDetails = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        const currentFileDetails = {
          name: file.name,
          mime_type: file.type,
          extension: file.name.split('.').pop(),
          size: file.size,
        };

        fileDetails.push(currentFileDetails);
      }

      return fileDetails
    },

    async generateUniqueURLsForFiles(filesDetails, workspaceId) {
        if (!filesDetails || filesDetails.length === 0) {
          return false;
        }

        const payload = {
          workspace_id: workspaceId,
          files: filesDetails,
        };

        const url = apiUrl + 'api/media_library/assets/generate-signed-url';
        // Get signed URL from backend
        try {
          const response = await proxy.post(url, payload);
          return response.data.data
        } catch (error) {
          console.error('Error uploading file:', error);
          return false
        }
    },

    async uploadMediaToGCS(signedURLFilesDetails, files, callbackFunction) {
      // setting loaders for video upload
      callbackFunction('local-property', {
        propertyName: 'mediaUploadLoader',
        value: true,
      })

      callbackFunction('local-property', {
        objectName: 'progressBar',
        propertyName: 'video',
        value: 0,
      })

      callbackFunction('initializeVideoUpload', {})

      const uploadedFiles = []

      try {
        for (const signedURLFilesDetail of signedURLFilesDetails) {
          // Find the corresponding file in the original file list
          const orignalFile = files.find(f =>
            f.name === signedURLFilesDetail.name && f.size === signedURLFilesDetail.size
          );
          if (!orignalFile) {
            console.error(`File not found: ${signedURLFilesDetail.name}`);
            continue; // Skip this file if it's not found
          }

          // XML is not promise-based, so we need to wrap it in a promise the
          await new Promise((resolve, reject) => {
            const self = this;
            const ajax = new XMLHttpRequest();

            ajax.upload.addEventListener('progress', function (progressEvent) {
              self.CSVideoUploadProgressHandler(progressEvent, callbackFunction);
            });

            ajax.addEventListener('load', function (loadEvent) {
              uploadedFiles.push(signedURLFilesDetail)
              resolve(loadEvent.target.responseText);
            });

            ajax.addEventListener('error', function (loadEvent) {
              reject(new Error('Upload failed'));
              self.CSVideoUploadErrorHandler(loadEvent, callbackFunction);
            });

            ajax.open('PUT', signedURLFilesDetail.signed_url);
            ajax.setRequestHeader('Content-Type', signedURLFilesDetail.mime_type);
            ajax.send(orignalFile);
          });
        }

        return uploadedFiles
      } catch (error) {
        console.error(error);
        this.alertMessage(error?.message || 'Error upload media', 'error')
      }
    },

    async UploadedCSVideoHandlerForGCS(signedURLFilesDetail, workspaceId) {
      const payload = {
        workspace_id: workspaceId,
        files: signedURLFilesDetail,
      };

      const url = apiUrl + 'api/media_library/assets/process-uploaded-gcs-media';
      try {
        const response = await proxy.post(url, payload);
        return response.data
      } catch (error) {
        console.error('Error uploading file:', error);
        this.alertMessage(error?.message || 'Error uploading file', 'error')
        return false
      }
    },

    /**
     * Process Composer Video Upload
     * @param {FormData} formData
     * @param event - progress event
     * @param callbackFunction - callback function
     */
    CSProcessVideoUpload(event, formData, callbackFunction) {
      console.debug('Method:processVideoUpload-composer', event, formData)
      // setting loaders for video upload
      callbackFunction('local-property', {
        propertyName: 'mediaUploadLoader',
        value: true,
      })
      callbackFunction('local-property', {
        objectName: 'progressBar',
        propertyName: 'video',
        value: 0,
      })
      callbackFunction('initializeVideoUpload', {})
      const self = this
      const ajax = new XMLHttpRequest()

      ajax.upload.addEventListener('progress', function (progressEvent) {
        self.CSVideoUploadProgressHandler(progressEvent, callbackFunction)
      })

      ajax.addEventListener('load', function (loadEvent) {
        self.CSVideoUploadCompleteHandler(loadEvent, callbackFunction)
      })

      ajax.addEventListener('error', function (loadEvent) {
        self.CSVideoUploadErrorHandler(loadEvent, callbackFunction)
      })

      ajax.open('POST', uploadMediaAssetUrl)
      ajax.setRequestHeader('Authorization', 'Bearer ' + this.getJWTToken)
      ajax.send(formData)
    },

    /**
     * This method will update the progress(percentage) of video uploading
     * @param event - progress event
     * @param callbackFunction - callback function
     */
    CSVideoUploadProgressHandler(event, callbackFunction) {
      console.debug('Method:videoUploadProgressHandler', event)
      let percent = (event.loaded / event.total) * 100
      percent = Math.round(percent)
      callbackFunction('local-property', {
        objectName: 'progressBar',
        propertyName: 'video',
        value: percent,
      })
    },

    /**
     * This method will be called when video uploaded completely.
     * @param event - event object
     * @param callbackFunction - callback function
     */
    CSVideoUploadCompleteHandler(event, callbackFunction) {
      console.debug('Action:videoUploadCompleteHandler-composer', event)
      try {
        let response = event.target.responseText
        response = JSON.parse(response)

        if (response.status === true && response?.media_container?.length) {
          const video = response.media_container.map(media => ({
            name: media.name || '',
            title: media.title || '',
            mime_type: media.mime_type || '',
            link: media.link || '',
            duration_seconds: media.duration_seconds || 0,
            converted_mime_type: media.converted_mime_type ? media.converted_mime_type : '',
            size: media.size || 0,
            thumbnail: media.thumbnail || '',
            thumbnails_suggestions: media.thumbnails_suggestions || [],
            converted_video: media.converted_video || '',
            converted_link: media.converted_link || '',
            width: media.width || 0,
            height: media.height || 0,
            is_converted: media.is_converted || false,
          }));

          // setting state of uploaded video details
          callbackFunction('addMedia', {
            mediaType: 'video',
            media: video,
          })
        } else if (response.storageFull) {
          this.setMediaStorageLimit(response.usedStorage)
          this.$bvModal.show('media-storage-limits-exceeded-modal')
        } else if (
            response.message &&
            response.message.includes('format is not correct')
        ) {
          this.alertMessage(response.message, 'error')
        } else {
          this.alertMessage('Unable to upload video.', 'error')
        }
      } catch (e) {
        console.error(
            'Exception: videoFileUploadCompleteHandler-Composer-v2',
            e
        )
        this.alertMessage('Unable to upload video.', 'error')
      }
      // hide loader of video upload
      this.mediaUploadLoader = false
      callbackFunction('local-property', {
        propertyName: 'mediaUploadLoader',
        value: false,
      })
    },

    /**
     * This method will be called if any exception is generated in the process of video upload
     * @param event - event object
     * @param callbackFunction - callback function
     */
    CSVideoUploadErrorHandler(event, callbackFunction) {
      console.debug('Method:videoFileUploadErrorHandler', event)
      this.alertMessage(UNKNOWN_ERROR, 'error')
      // hide loader of video upload
      callbackFunction('local-property', {
        propertyName: 'mediaUploadLoader',
        value: false,
      })
    },

    /**
     * @description - This method is used to Process Link
     * @param type {string}
     * @param urls {array}
     * @param getTemplateText {function}
     * @param getSharingDetails {function}
     * @param cancelledLink {string}
     * @param callbackFunction {function} - callback function params (actionType {string}, payload: {object})
     * @param savedLinks {array}
     * @param isMediaEnabled
     * @returns Object
     */
    CSProcessLinks(
        type,
        urls,
        getTemplateText,
        getSharingDetails,
        cancelledLink,
        callbackFunction,
        savedLinks = [],
        isMediaEnabled = false
    ) {
      console.debug('Method:checkLinkStatus ', type, urls)
      if (
          this.getWorkspaces.activeWorkspace.utmStatus &&
          this.checkLongLinkExistence(urls)
      ) {
        this.CSProcessLinksWithUtm(
            type,
            urls,
            getTemplateText,
            getSharingDetails,
            cancelledLink,
            callbackFunction,
            savedLinks,
            isMediaEnabled
        )
      } else if (
          this.getWorkspaces.activeWorkspace.shortener &&
          this.checkLongLinkExistence(urls)
      ) {
        this.CSProcessLinksWithShortener(
            type,
            urls,
            getTemplateText,
            getSharingDetails,
            cancelledLink,
            callbackFunction,
            savedLinks,
            isMediaEnabled
        )
      } else {
        if (!isMediaEnabled)
          this.CSParseLinkPreview(
              type,
              urls,
              getSharingDetails,
              cancelledLink,
              callbackFunction
          )
      }
    },

    /** Process Links with UTM
     * @param type {string}
     * @param urls {array}
     * @param getTemplateText {function}
     * @param getSharingDetails {function}
     * @param cancelledLink {string}
     * @param callbackFunction {function} - callback function params (actionType {string}, payload: {object})
     * @param savedLinks {array}
     * @param isMediaEnabled
     * @returns Object
     */
    CSProcessLinksWithUtm(
        type,
        urls,
        getTemplateText,
        getSharingDetails,
        cancelledLink,
        callbackFunction,
        savedLinks,
        isMediaEnabled = false
    ) {
      const details = getSharingDetails()
      let message = getTemplateText()
      console.debug('Method::processWithUTM', message, urls)
      const stateObject = this
      const selectedUtm = this.fetchActiveUtm
      const finalURLs = []
      urls.forEach(function (url, index) {
        if (!stateObject.isShortLink(url)) {
          if (
              url.indexOf('utm_medium') === -1 &&
              url.indexOf('utm_source') === -1 &&
              url.indexOf('utm_content') === -1
          ) {
            const response = stateObject.fetchUtmBasedLinks(url, selectedUtm)
            message = message.replaceAll(
                urls[index],
                response[type.toLowerCase()]
            )
            if (
                details.image.length === 0 &&
                (!details.video || details.video.link === '')
            ) {
              if (index === 0) {
                // set first url as main url
                callbackFunction('details', {
                  propertyName: 'url',
                  value: response[type.toLowerCase()],
                })
              }
              if (type === 'common') {
                for (const prop in response) {
                  // skip loop if the property is from prototype
                  if (!Object.hasOwn(response, prop)) continue

                  if (prop !== 'auto_add_social_channel')
                    finalURLs.push(response[prop])
                  switch (prop) {
                    case 'facebook':
                    case 'twitter':
                    case 'linkedin':
                    case 'tumblr':
                    case 'instagram':
                    case 'youtube':
                    case 'threads':
                    case 'bluesky':
                      callbackFunction('details', {
                        propertyName: prop + '_url',
                        value: response[prop],
                      })
                      break
                    case 'pinterest':
                      callbackFunction('details', {
                        propertyName: 'pinterest_url',
                        value: response[prop],
                      })
                      callbackFunction('details', {
                        propertyName: 'source_url',
                        value: response[prop],
                      })
                      break
                    case 'gmb': {
                      callbackFunction('details', {
                        propertyName: 'gmb_url',
                        value: response[prop],
                      })
                      callbackFunction('details', {
                        propertyName: 'cta_link',
                        value: response[prop],
                      })
                      break
                    }
                  }
                }
              } else {
                finalURLs.push(response[type.toLowerCase()])
              }
            } else {
              finalURLs.push(response[type.toLowerCase()])
            }
          } else {
            finalURLs.push(url)
          }
        }
      })
      callbackFunction('details', { propertyName: 'message', value: message })
      callbackFunction('handle-change', {})
      const hasUrlsToProcess = finalURLs.length > 0
      const hasShortenerAndUrlsExist =
          this.getWorkspaces.activeWorkspace.shortener &&
          this.checkLongLinkExistence(finalURLs)

      if (!hasUrlsToProcess) {
        return
      }

      if (hasShortenerAndUrlsExist) {
        return this.CSProcessLinksWithShortener(
            type,
            finalURLs,
            getTemplateText,
            getSharingDetails,
            cancelledLink,
            callbackFunction,
            savedLinks,
            isMediaEnabled
        )
      }

      if (!isMediaEnabled) {
        return this.CSParseLinkPreview(
            type,
            finalURLs,
            getSharingDetails,
            cancelledLink,
            callbackFunction
        )
      }
    },

    /**
     * Process Links with Shortener
     * @param type {string}
     * @param urls {array}
     * @param getTemplateText {function}
     * @param getSharingDetails {function}
     * @param cancelledLink {string}
     * @param callbackFunction {function} - callback function params (actionType {string}, payload: {object})
     * @param savedLinks {array}
     * @param isMediaEnabled
     * @returns {Object}
     */
    CSProcessLinksWithShortener(
        type,
        urls,
        getTemplateText,
        getSharingDetails,
        cancelledLink,
        callbackFunction,
        savedLinks,
        isMediaEnabled = false
    ) {
      console.debug('Method:CSFetchShortLinks', type, urls)
      if (savedLinks && savedLinks.length > 0) {
        const url = urls.filter((item) => {
          return !savedLinks.some(function (el) {
            return el.original === item
          })
        })
        urls = url
      }
      if (urls && urls.length === 0) return
      const details = getSharingDetails()
      if (
          details.image.length === 0 &&
          (!details.video || details.video.link === '') &&
          !details.url &&
          urls[0] !== cancelledLink
      ) {
        callbackFunction('details', { propertyName: 'url', value: urls[0] })
        if (type === 'common') {
          callbackFunction('details', {
            propertyName: 'facebook_url',
            value: urls[0],
          })
          callbackFunction('details', {
            propertyName: 'twitter_url',
            value: urls[0],
          })
          callbackFunction('details', {
            propertyName: 'linkedin_url',
            value: urls[0],
          })
          callbackFunction('details', {
            propertyName: 'pinterest_url',
            value: urls[0],
          })
          callbackFunction('details', {
            propertyName: 'tumblr_url',
            value: urls[0],
          })
          callbackFunction('details', {
            propertyName: 'instagram_url',
            value: urls[0],
          })
          callbackFunction('details', {
            propertyName: 'youtube_url',
            value: urls[0],
          })
          callbackFunction('details', {
            propertyName: 'gmb_url',
            value: urls[0],
          })
          callbackFunction('details', {
            propertyName: 'threads_url',
            value: urls[0],
          })
          callbackFunction('details', {
            propertyName: 'bluesky_url',
            value: urls[0],
          })
          callbackFunction('details', {
            propertyName: 'cta_link',
            value: urls[0],
          })
          callbackFunction('details', {
            propertyName: 'source_url',
            value: urls[0],
          })
        }
        callbackFunction('local-property', {
          propertyName: 'linkShortenerLoader',
          value: true,
        }) // set link loader
      }
      callbackFunction('handle-change', {})
      this.postRequest(
          fetchShortLinksUrl,
          {
            urls,
            workspace_id: this.getWorkspaces.activeWorkspace._id,
          },
          (response) => {
            this.CSProcessShortLinks(
                urls,
                type,
                response,
                getTemplateText,
                getSharingDetails,
                cancelledLink,
                callbackFunction,
                isMediaEnabled
            )
            callbackFunction('local-property', {
              propertyName: 'linkShortenerLoader',
              value: false,
            })
          },
          (error) => {
            console.error('Exception in CSFetchShortLinks', error)
            callbackFunction('local-property', {
              propertyName: 'linkShortenerLoader',
              value: false,
            })
          }
      )
    },

    /**
     * Process short links
     * @param urls {array}
     * @param type {string}
     * @param response {object}
     * @param getTemplateText {function}
     * @param getSharingDetails {function}
     * @param cancelledLink {string}
     * @param callbackFunction {function} - callback function params (actionType {string}, payload: {object})
     * @param isMediaEnabled
     * @returns []
     */
    CSProcessShortLinks: function (
        urls,
        type,
        response,
        getTemplateText,
        getSharingDetails,
        cancelledLink,
        callbackFunction,
        isMediaEnabled
    ) {
      console.debug('Method:CSProcessShortLinks', urls, type)
      const details = getSharingDetails()
      let url = urls[0]
      if (response.data.status === true) {
        if (response.data.links.length) {
          let message = getTemplateText() || details.message
          response.data.links.forEach(function (el, index) {
            callbackFunction('handle-url', {
              original: el.long,
              short: el.short,
            })
            if (el.short) {
              if (message.indexOf(el.long) > -1) {
                message = message.replaceAll(el.long, el.short)
              }
              if (el.long === details.url) {
                url = el.short
                callbackFunction('details', {
                  propertyName: 'url',
                  value: el.short,
                })
                if (type === 'gmb') {
                  callbackFunction('details', {
                    propertyName: 'cta_link',
                    value: el.short,
                  })
                } else if (type === 'pinterest') {
                  callbackFunction('details', {
                    propertyName: 'source_url',
                    value: el.short,
                  })
                }
              }
              if (type === 'common') {
                if (el.long === details.facebook_url) {
                  callbackFunction('details', {
                    propertyName: 'facebook_url',
                    value: el.short,
                  })
                }
                if (el.long === details.twitter_url) {
                  callbackFunction('details', {
                    propertyName: 'twitter_url',
                    value: el.short,
                  })
                }
                if (el.long === details.linkedin_url) {
                  callbackFunction('details', {
                    propertyName: 'linkedin_url',
                    value: el.short,
                  })
                }
                if (el.long === details.pinterest_url) {
                  callbackFunction('details', {
                    propertyName: 'pinterest_url',
                    value: el.short,
                  })
                  callbackFunction('details', {
                    propertyName: 'source_url',
                    value: el.short,
                  })
                }
                if (el.long === details.tumblr_url) {
                  callbackFunction('details', {
                    propertyName: 'tumblr_url',
                    value: el.short,
                  })
                }
                if (el.long === details.instagram_url) {
                  callbackFunction('details', {
                    propertyName: 'instagram_url',
                    value: el.short,
                  })
                }
                if (el.long === details.youtube_url) {
                  callbackFunction('details', {
                    propertyName: 'youtube_url',
                    value: el.short,
                  })
                }
                if (el.long === details.threads_url) {
                    callbackFunction('details', {
                        propertyName: 'threads_url',
                        value: el.short,
                    })
                }
                if (el.long === details.bluesky_url) {
                  callbackFunction('details', {
                    propertyName: 'bluesky_url',
                    value: el.short,
                  })
                }
                if (el.long === details.gmb_url) {
                  callbackFunction('details', {
                    propertyName: 'gmb_url',
                    value: el.short,
                  })
                  callbackFunction('details', {
                    propertyName: 'cta_link',
                    value: el.short,
                  })
                }
              }
            }
          })

          callbackFunction('details', {
            propertyName: 'message',
            value: message,
          })
          if (
              details.image.length === 0 &&
              (!details.video || details.video.link === '') &&
              urls[0] !== cancelledLink
          ) {
            callbackFunction('details', { propertyName: 'url', value: url })
          }
        }
      }
      callbackFunction('handle-change', {})
      if (!isMediaEnabled)
        this.CSParseLinkPreview(
            type,
            urls,
            getSharingDetails,
            cancelledLink,
            callbackFunction
        )
    },

    /**
     * Parse Link Preview
     * @param type {string}
     * @param urls {array}
     * @param getSharingDetails {function}
     * @param cancelledLink {string}
     * @param callbackFunction {function} - callback function params (actionType {string}, payload: {object})
     * @returns []
     */
    CSParseLinkPreview(
        type,
        urls,
        getSharingDetails,
        cancelledLink,
        callbackFunction
    ) {
      console.debug(
          'Method::CSParseLinkPreview',
          urls,
          type,
          getSharingDetails()
      )
      const details = getSharingDetails()

      let previewUrl = urls[0]
      if (details.url) {
        previewUrl = details.url
      }
      if (
          previewUrl !== cancelledLink &&
          !this.isLinkPreviewAdded(details) &&
          type !== 'youtube' &&
          type !== 'tiktok'
      ) {
        if (
            !details.url &&
            details.image.length === 0 &&
            (!details.video || details.video.link === '')
        ) {
          callbackFunction('local-property', {
            propertyName: 'linkPreviewLoader',
            value: true,
          })
          callbackFunction('details', {
            propertyName: 'url',
            value: previewUrl,
          })
          switch (type) {
            case 'common':
              callbackFunction('details', {
                propertyName: 'facebook_url',
                value: urls[0],
              })
              callbackFunction('details', {
                propertyName: 'twitter_url',
                value: urls[0],
              })
              callbackFunction('details', {
                propertyName: 'linkedin_url',
                value: urls[0],
              })
              callbackFunction('details', {
                propertyName: 'pinterest_url',
                value: urls[0],
              })
              callbackFunction('details', {
                propertyName: 'tumblr_url',
                value: urls[0],
              })
              callbackFunction('details', {
                propertyName: 'instagram_url',
                value: urls[0],
              })
              callbackFunction('details', {
                propertyName: 'youtube_url',
                value: urls[0],
              })
              callbackFunction('details', {
                propertyName: 'gmb_url',
                value: urls[0],
              })
                callbackFunction('details', {
                    propertyName: 'threads_url',
                    value: urls[0],
                })
              callbackFunction('details', {
                propertyName: 'bluesky_url',
                value: urls[0],
              })
              callbackFunction('details', {
                propertyName: 'cta_link',
                value: urls[0],
              })
              callbackFunction('details', {
                propertyName: 'source_url',
                value: urls[0],
              })
              break
            case 'gmb':
              callbackFunction('details', {
                propertyName: 'cta_link',
                value: urls[0],
              })
              break
            case 'pinterest':
              callbackFunction('details', {
                propertyName: 'source_url',
                value: urls[0],
              })
              break
            case 'multi-threads':
              callbackFunction('details', {
                propertyName: 'url',
                value: urls[0],
              })
              break
          }
          callbackFunction('local-property', {
            propertyName: 'linkPreviewLoader',
            value: true,
          })
        }
        callbackFunction('local-property', {
          propertyName: 'cancelledLink',
          value: previewUrl,
        })
        callbackFunction('handle-change', {})
        if (type === 'common') {
          let newURl
          try {
            newURl = new URL(previewUrl)
            this.fetchComposerVariation(newURl, details.message)
          } catch (_) {
            newURl = 'http://' + previewUrl
            this.fetchComposerVariation(newURl, details.message)
          }
        }
        this.CSFetchLinkPreview(
            type,
            previewUrl,
            getSharingDetails,
            callbackFunction
        )
      } else {
        callbackFunction('local-property', {
          propertyName: 'linkPreviewLoader',
          value: false,
        })
      }
    },

    /**
     * Fetch link preview from the api
     * @param type {string}
     * @param url {string}
     * @param getSharingDetails {function}
     * @param callbackFunction {function} - callback function params (actionType {string}, payload: {object})
     */
    CSFetchLinkPreview(type, url, getSharingDetails, callbackFunction) {
      console.debug('Method:fetchLinkPreview-EditorBox', url, type)
      callbackFunction('local-property', {
        propertyName: 'linkPreviewLoader',
        value: true,
      })
      proxy
          .post(fetchLinkPreviewUrl, { url })
          .catch((error) => {
            callbackFunction('local-property', {
              propertyName: 'linkPreviewLoader',
              value: false,
            })
            callbackFunction('removeLinkPreview', {})
            console.error('Fetch Link Preview Error', error)
          })
          .then((response) => {
            this.CSProcessLinkPreview(
                type,
                url,
                response,
                getSharingDetails,
                callbackFunction
            )
            callbackFunction('local-property', {
              propertyName: 'linkPreviewLoader',
              value: false,
            })
          })
    },

    /**
     * Process link preview response
     * @param type
     * @param link
     * @param response
     * @param getSharingDetails {function}
     * @param callbackFunction {function} - callback function params (actionType {string}, payload: {object})
     */
    CSProcessLinkPreview(
        type,
        link,
        response,
        getSharingDetails,
        callbackFunction
    ) {
      const details = getSharingDetails()
      let url = link
      console.debug('Method:CSProcessLinkPreview', link)
      if (response.data.status) {
        let title = ''
        let twitterTitle = ''
        let description = ''
        let twitterDescription = ''
        let website = ''
        let twitterWebsite = ''
        let image = ''
        let imageArray = []
        let twitterImage = []
        const imageSuggestions = []
        const twitterImageSuggestions = []

        // for unique images
        response.data.images.forEach(function (el, index) {
          if (imageSuggestions.includes(el) === false) {
            imageSuggestions.push(decodeURI(el))
          }

          if (twitterImageSuggestions.includes(el) === false) {
            twitterImageSuggestions.push(decodeURI(el))
          }
        })

        if (response.data.facebook || response.data.twitter) {
          if (response.data.twitter) {
            twitterTitle = response.data.twitter.title
            twitterDescription = response.data.twitter.description
            twitterWebsite = response.data.twitter.website

            if (
                twitterWebsite !== 'www.youtube.com' ||
                twitterWebsite !== 'www.dailymotion.com'
            ) {
              if (response.data.twitter.image) {
                try {
                  url = new URL(response.data.twitter.image)
                  if (url !== decodeURI(url)) url = encodeURI(url)
                  twitterImage = [decodeURI(url)]
                } catch (_) {
                  url = [twitterWebsite + response.data.twitter.image]
                  if (new URL(url)) {
                    if (url !== decodeURI(url)) url = encodeURI(url)
                    twitterImage = [decodeURI(url)]
                  }
                }
                if (
                    twitterImageSuggestions.includes(
                        response.data.twitter.image
                    ) === false
                ) {
                  twitterImageSuggestions.push(
                      decodeURI(response.data.twitter.image)
                  )
                }
              } else {
                twitterImage = [
                  'https://storage.googleapis.com/lumotive-web-storage/no-image-available-small.png',
                ]
              }
            }
          }

          if (response.data.facebook) {
            if (response.data.facebook.title) {
              title = response.data.facebook.title
            } else if (response.data.meta.title) {
              title = response.data.meta.title
            }

            if (response.data.facebook.description) {
              description = response.data.facebook.description
            } else if (response.data.meta.description) {
              description = response.data.meta.description
            }

            website = response.data.facebook.website

            if (response.data.facebook.image) {
              try {
                url = new URL(response.data.facebook.image)
                if (url !== decodeURI(url)) url = encodeURI(url)
                image = url
                imageArray = [decodeURI(image)]
              } catch (_) {
                url = website + response.data.facebook.image
                if (new URL(url)) {
                  if (url !== decodeURI(url)) url = encodeURI(url)
                  image = url
                  imageArray = [decodeURI(image)]
                }
              }

              if (imageSuggestions.includes(image) === false) {
                imageSuggestions.push(decodeURI(image))
              }
            } else if (imageSuggestions.length > 0) {
              image = imageSuggestions[0]
              imageArray = [decodeURI(image)]
            }
          }
        } else {
          if (response.data.meta) {
            title = twitterTitle = response.data.meta.title
            description = twitterDescription = response.data.meta.description
          }
        }

        // using same images if images are already added
        if (details.image.length) {
          imageArray = details.image
        }

        const linkPreview = {
          title,
          description,
          website,
          image: imageArray,
          twitter_title: twitterTitle,
          twitter_description: twitterDescription,
          twitter_website: twitterWebsite,
          twitter_image: twitterImage,
          image_suggestions: imageSuggestions,
          twitter_image_suggestions: twitterImageSuggestions,
          singleImage: image,
        }

        callbackFunction('setLinkPreview', { value: linkPreview })
        callbackFunction('local-property', {
          propertyName: 'linkPreviewLoader',
          value: false,
        })
      } else {
        callbackFunction('local-property', {
          propertyName: 'linkPreviewLoader',
          value: false,
        })
        callbackFunction('removeLinkPreview', {})
      }
    },

    async fetchComposerMentionSuggestions(text, platforms = []) {
      console.log(
          'METHOD::fetchComposerMentionSuggestions ~ text, platforms -> ',
          text,
          platforms
      )
      if (platforms.length && text.length > 2) {
        try {
          const res = await proxy.post(fetchSocialMentionSuggestionsUrl, {
            keyword: text,
            platforms,
            workspace_id: this.getWorkspaces.activeWorkspace._id
          });

          if (res && res.data && res.data.suggestions) {
            return res.data.suggestions;
          }
        } catch (err) {
          // Optionally, you can return a default value or handle the error in another way
          return null;
        }
      }
      return null
    },

    /**
     * For generating separate box link preview base on common box.
     * @param platform
     * @param common
     * @returns {*}
     */
    CSParseBoxPreview(platform, common) {
      platform = platform.toLowerCase()
      if (platform === 'twitter') {
        return {
          title: common.twitter_title,
          description: common.twitter_description,
          website: common.twitter_website,
          image: common.twitter_image,
          image_suggestions: common.image_suggestions,
        }
      }
      if (['facebook', 'linkedin', 'threads', 'bluesky'].includes(platform)) {
        return {
          title: common.title,
          description: common.description,
          website: common.website,
          image: common.image,
          image_suggestions: common.image_suggestions,
        }
      }
      if (platform === 'instagram') return { image: common.image }

      return {
        image: common.image ? [].concat(common.image[0]) : [],
      }
    },

    async CSFetchPost(id) {
      // get the plan.
      const response = await proxy.post(fetchPlanUrl, {
        id,
        workspace_id: this.getWorkspaces.activeWorkspace._id,
      })

      if (response.data && response.data.status === true) {
        return response.data
      }
      return false
    },

    filterComments(comments) {
      const members = this.getWorkspaces.activeWorkspace.members
      comments.filter((comment) => {
        members.filter((member) => {
          if (member.user) {
            if (comment.user_id === member.user._id) {
              comment.user = member.user
            }
          }
        })
      })
      return comments
    },

    isLinkPreviewAdded(sharingDetails) {
      if (sharingDetails.url && sharingDetails.url !== '') {
        if (sharingDetails.image && sharingDetails.image.length) return true
        if (sharingDetails.title) return true
        if (sharingDetails.website) return true
        return !!sharingDetails.description
      }
      return false
    },

    isImagesHasGif(images) {
      let gifCount = 0
      if (images && images.length > 0) {
        images.forEach(function (el, index) {
          if (el.href) el = el.href
          if (el.split('.').pop() === 'gif') gifCount = gifCount + 1
        })
      }
      return gifCount
    },
    // for tailwind because tailwind doesn't support concatenation in class name
    getSocialColor(platform) {
      switch (platform) {
        case 'facebook':
          return 'text-cs-blue'
        case 'twitter':
          return 'text-cs-blue'
        case 'linkedin':
          return 'text-cs-blue'
        case 'instagram':
          return 'text-cs-red'
        case 'pinterest':
          return 'text-cs-red'
        case 'youtube':
          return 'text-cs-red'
        case 'gmb':
          return 'text-cs-blue'
        case 'tumblr':
          return 'text-black-200'
        case 'tiktok':
          return 'text-cs-violet'
        case 'threads':
          return 'text-cs-violet'
        default:
          return 'text-cs-blue'
      }
    },
    getSocialImage(platform) {
      switch (platform) {
        case 'facebook':
          return 'facebook-rounded.svg'
        case 'twitter':
          return 'twitter-x-rounded.svg'
        case 'linkedin':
          return 'linkedin-rounded.svg'
        case 'instagram':
          return 'instagram-rounded.svg'
        case 'pinterest':
          return 'pinterest-rounded.svg'
        case 'youtube':
          return 'youtube-rounded.png'
        case 'gmb':
          return 'gmb-rounded.svg'
        case 'tumblr':
          return 'tumblr-rounded.svg'
        case 'tiktok':
          return 'tiktok-rounded.svg'
        case 'threads':
          return 'threads-rounded.svg'
        case 'bluesky':
          return 'bluesky-rounded.svg'
      }
    },
    getSocialIcon(platform) {
      switch (platform) {
        case 'facebook':
          return 'facebook-icon.svg'
        case 'twitter':
          return 'twitter-x-icon.svg'
        case 'linkedin':
          return 'linkedin-icon.svg'
        case 'instagram':
          return 'instagram-icon.svg'
        case 'pinterest':
          return 'pinterest-icon.svg'
        case 'youtube':
          return 'youtube.png'
        case 'gmb':
          return 'gmb-icon.svg'
        case 'tumblr':
          return 'tumblr-icon.svg'
        case 'tiktok':
          return 'tiktok-icon.svg'
        case 'threads':
          return 'threads-icon.svg'
        case 'bluesky':
          return 'bluesky-icon.svg'
        default:
          return 'facebook-icon.svg'
      }
    },
    getSocialIconColor(platform) {
      switch (platform) {
        case 'facebook':
          return 'bg-cs-blue'
        case 'twitter':
          return 'bg-cs-blue'
        case 'linkedin':
          return 'bg-cs-blue'
        case 'instagram':
          return 'bg-cs-red'
        case 'pinterest':
          return 'bg-cs-red'
        case 'youtube':
          return 'bg-cs-red'
        case 'gmb':
          return 'bg-cs-blue'
        case 'tumblr':
          return 'bg-cs-yellow'
        case 'tiktok':
          return 'bg-cs-violet'
        case 'threads':
          return 'bg-cs-violet'
        case 'bluesky':
          return 'bg-cs-violet'
        default:
          return 'bg-cs-blue'
      }
    },
    getSocialBackground(platform) {
      switch (platform) {
        case 'facebook':
          return 'bg-cs-light-blue'
        case 'twitter':
          return 'bg-cs-light-blue'
        case 'linkedin':
          return 'bg-cs-light-blue'
        case 'instagram':
          return 'bg-cs-light-red'
        case 'pinterest':
          return 'bg-cs-light-red'
        case 'youtube':
          return ''
        case 'gmb':
          return 'bg-cs-light-blue'
        case 'tumblr':
          return 'bg-cs-light-violet'
        case 'tiktok':
          return 'bg-cs-light-violet'
        case 'threads':
            return 'bg-cs-light-blue'
        case 'bluesky':
          return 'bg-cs-light-blue'
        default:
          return 'bg-cs-blue'
      }
    },

    getMentionedUsersIds(text) {
      const regex =
          /@[a-zA-Z0-9!#$%^&*()_+\-=[\]{};':"\\|,.<>/?-\u0041-\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*/g
      const mentionedUsersIds = []
      const mentionedUsers = text.match(regex)
      if (mentionedUsers) {
        // filter the name and after that get the value by index.
        mentionedUsers.filter((name, index) => {
          const mentionedId = this.getActiveWorkspaceMembersName.indexOf(
              name.substr(1)
          )
          mentionedUsersIds.push(this.getActiveWorkspaceMembersIds[mentionedId])
        })
      }
      return mentionedUsersIds
    },

    getSharingImageUploadLoader(type) {
      switch (type) {
        case 'common':
          return this.getPublishLoaders.uploadCommonSharingImage
        case 'facebook':
          return this.getPublishLoaders.uploadFacebookSharingImage
        case 'twitter':
          return this.getPublishLoaders.uploadTwitterSharingImage
        case 'linkedin':
          return this.getLinkedinSharingLoaders.upload_sharing_image
        case 'pinterest':
          return this.getPublishLoaders.uploadPinterestSharingImage
        case 'tumblr':
          return this.getPublishLoaders.uploadTumblrSharingImage
        case 'instagram':
          return this.getInstagramSharingLoaders.upload_sharing_image
        case 'gmb':
          return this.getGmbSharingLoaders.upload_sharing_image
        default:
          return { status: false, position: -1 }
      }
    },

    getUrlHostName(url) {
      const urlParts = /^(?:\w+:\/\/)?([^/]+)([^?]*)\??(.*)$/.exec(url)
      return urlParts[1] ? urlParts[1] : ''
    },

    isValidDate(d) {
      return d instanceof Date && !isNaN(d)
    },

    /**
     * Validate pinterest source url
     * @param sourceUrl
     * @returns {boolean}
     */
    isValidPinterestSourceUrl(sourceUrl) {
      if (this.isValidURL(sourceUrl)) {
        return (
            sourceUrl.indexOf('https://') !== -1 ||
            sourceUrl.indexOf('http://') !== -1
        )
      }
      return false
    },
    isPremiumTwitter(account, ignorePlatform = false) {
      return (
        (account?.channel_type?.toLowerCase() === 'twitter' ||
          ignorePlatform) &&
          ['premium', 'premiumplus', 'basic'].includes(account?.subscription_type?.toLowerCase())

      )
    }
  },
}

export default ComposerHelperMixin
